import { LoadingOverlay, Space, Stack, TextInput } from '@mantine/core';
import { useContext } from 'react';
import { DndProvider } from 'react-dnd-latest';
import { HTML5Backend } from 'react-dnd-html5-backend-latest';
import ContractTextBlock from '../../../../Organismns/Contract/ContractTemplateTextBlock';
import { ContractTemplateContext } from '../../../../Service/Context/ContractTemplateContext';
import ContractDocumentBlock from '../../../../Organismns/Contract/ContractTemplateDocumentBlock';
import { ContractTemplateBlockButtons } from '../../../../Organismns/Contract/AddBlockButtons';
import { RichInput } from '../../../../Organismns/tiptap/TiptapEditorInput';
import DocumentBubbleMenu from '../../../../Organismns/tiptap/toolbars/BubbleMenu';
import { TiptapS } from '../../../../Service/TiptapS';
import SkeletonItems from '../../../../Atoms/SkeletonItems';

const ContractTemplateContentSection = () => {
  const { loading, movingBlock, template, savePatch, aboveBlocks, belowBlocks } = useContext(ContractTemplateContext);
  const { label, title, subject, positions } = template ?? {};
  const isEmpty = aboveBlocks.length === 0 && belowBlocks.length === 0;

  return (
    <>
      {template && (
        <TextInput
          mb="sm"
          defaultValue={label ?? ''}
          label="Name (für Kunden sichtbar)"
          onBlur={(e) => savePatch({ label: e.currentTarget.value })}
        />
      )}
      {template && (
        <RichInput
          label="Überschrift"
          value={subject ?? ''}
          patchField={async (htmlString) => {
            const res = await savePatch({ subject: htmlString });
            return res !== null;
          }}
          menu={<DocumentBubbleMenu />}
          styles={TiptapS.TextInputStyles}
        />
      )}
      <Space h="xs" />
      {template && (
        <RichInput
          label="Titel"
          value={title ?? ''}
          patchField={async (htmlString) => {
            const res = await savePatch({ title: htmlString });
            return res !== null;
          }}
          styles={TiptapS.TextInputStyles}
        />
      )}
      <Space h="xl" />
      {loading && <SkeletonItems height={100} />}
      <DndProvider backend={HTML5Backend}>
        <Stack pos="relative" spacing={5}>
          <LoadingOverlay visible={movingBlock} overlayBlur={2} loaderProps={{ size: 'xl' }} />
          {aboveBlocks.map((textBlock, index) => (
            <ContractTextBlock key={textBlock.id} isAbove index={index} textBlock={textBlock} />
          ))}
          {positions && <ContractDocumentBlock />}
          {belowBlocks.map((textBlock, index) => (
            <ContractTextBlock key={textBlock.id} index={index} textBlock={textBlock} />
          ))}
        </Stack>
      </DndProvider>
      {isEmpty && template && <ContractTemplateBlockButtons isAbove withoutGap />}
    </>
  );
};

export default ContractTemplateContentSection;
